module.exports = __webpack_public_path__ + "static/media/google_play_button.168d2d06.svg";